var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.ExpertMode.Sections.Battery'),
        value: Math.round((_vm.latestPowerInverterReadApp.parameters || {}).Inverter_Bat_Power),
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.ExpertMode.Items.Power.Grid'),
        value: Math.round((_vm.latestGridMeterApp.parameters || {}).Meter_Grid_Power_Sum),
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.ExpertMode.Items.Power.PV'),
        value: Math.round((_vm.latestPvMeterApp.parameters || {}).Meter_PV_Power_Sum),
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.ExpertMode.Items.Power.Consumer'),
        value: Math.round(_vm.consumedPower),
        unit: 'W',
        hideFractionDigits: true
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.ExpertMode.Sections.Power'))+"\n  ")]),(_vm.isTechnician)?_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.expert_view_total_power_battery'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_Energy_Day / 1000,
        unit: 'kWh'
      },
      {
        label: _vm.$t('Web.expert_view_total_power_grid_feed'),
        value: (_vm.latestGridMeterApp.parameters || {}).Meter_Grid_Energy_Export_T1 / 1000,
        unit: 'kWh'
      },
      {
        label: _vm.$t('Web.expert_view_total_power_grid_reference'),
        value: (_vm.latestGridMeterApp.parameters || {}).Meter_Grid_Energy_Import_T1 / 1000,
        unit: 'kWh'
      },
      {
        label: _vm.$t('Web.expert_view_total_power_solar_feed'),
        value: (_vm.latestPvMeterApp.parameters || {}).Meter_PV_Energy_Import_T1 / 1000,
        unit: 'kWh'
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.expert_view_total_power_title'))+"\n  ")]):_vm._e(),(_vm.isTechnician)?_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.expert_view_battery_inverter_performance_discharge_set_point'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_Pac_set_UpperLimit_W || 0,
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_performance_charge_set_point'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_Pac_set_LowerLimit_W || 0,
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_charging_power'),
        value:
          (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_Pac_charge_max_LowerLimit_W ||
          'n/a',
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_discharging'),
        value:
          (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_Pac_discharge_max_UpperLimit_W ||
          0,
        unit: 'W',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_voltage_max'),
        value:
          (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_U_bat_set_max_UpperLimit_mV /
            1000 || 0,
        unit: 'V',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_voltage_min'),
        value:
          (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_U_bat_set_min_LowerLimit_mV /
            1000 || 0,
        unit: 'V',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_charging_current_max'),
        value:
          (_vm.latestPowerInverterReadApp.parameters || {}).Inverter_I_bat_charge_max_LowerLimit_mA /
            1000 || 0,
        unit: 'A'
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_discharging_current_max'),
        value:
          (_vm.latestPowerInverterReadApp.parameters || {})
            .Inverter_I_bat_discharge_max_UpperLimit_mA / 1000 || 0,
        unit: 'A'
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_cos_current'),
        value: _vm.cosPhiLatest
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_powerfactor'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).PowerFactor || 0,
        unit: '%'
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_q_fix_var'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).Q_fix_var || 0,
        unit: 'var'
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_q_cr_time'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).Q_CR_Time || 0,
        unit: 's'
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_qmax_smax'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).QMax_SMax || 0,
        unit: '%'
      },
      {
        label: _vm.$t('Web.ProductionData'),
        value: ((_vm.latestPowerInverterReadApp.parameters || {}).ProductionData || 0).toString(),
        ruleSubscriber: 'ar4105Monitoring',
        target: 'hidden'
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.ExpertMode.Items.Power.Inverter'))+"\n  ")]):_vm._e(),(_vm.isTechnician)?_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.ExpertMode.Items.Battery.MaxCharge'),
        value: (_vm.latestPower3ParameterPublisherApp.parameters || {}).LG_Battery_CH_LIMIT / 1000,
        unit: 'A'
      },
      {
        label: _vm.$t('Web.expert_view_battery_inverter_discharging_current'),
        value: (_vm.latestPower3ParameterPublisherApp.parameters || {}).LG_Battery_DCH_LIMIT / 1000,
        unit: 'A'
      },
      {
        label: _vm.$t('Web.ExpertMode.Items.Battery.Battery'),
        value: (_vm.latestLgBatteryApp.parameters || {}).LG_Battery_SOC || 0,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.ExpertMode.Items.Battery.Cycles'),
        value: (_vm.latestLgBatteryApp.parameters || {}).Battery_Module1_Cycles || 0,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.ExpertMode.Items.Battery.Voltage'),
        value: (_vm.latestLgBatteryApp.parameters || {}).Battery_Voltage || 0,
        unit: 'V',
        hideFractionDigits: true
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.Items.Battery.Title'))+"\n  ")]):_vm._e(),_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.expert_view_error_inverter'),
        value: (_vm.latestPower3ParameterPublisherApp.parameters || {}).System_SM_Inverter_Error,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_error_battery'),
        value: (_vm.latestPower3ParameterPublisherApp.parameters || {}).System_SM_Battery_Error,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_error_system'),
        value: (_vm.latestPower3ParameterPublisherApp.parameters || {}).System_SM_Status,
        hideFractionDigits: true
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.expert_view_error_title'))+"\n  ")]),_c('version-data',{attrs:{"device":_vm.device,"apiVersion":_vm.apiVersion}}),_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.expert_view_version_inverter_ens'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).ENS,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_version_inverter_pu'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).PU,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_version_inverter_bdc'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).BDC,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_version_inverter_hmi_app'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).HMI_APP,
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_version_inverter_hmi_fbl'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).HMI_FBL,
        hideFractionDigits: true
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.ExpertMode.Items.Inverter.title'))+"\n  ")]),(_vm.getAustriaSelected)?_c('parameter-block',{attrs:{"showToggle":true,"content":[
      {
        label: _vm.$t('Web.expert_view_cr_time_read'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).P_U_CRTime,
        unit: 's',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_recon_time_read'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).Recon_Time / 1000,
        unit: 's',
        hideFractionDigits: true
      },

      {
        label: _vm.$t('Web.expert_view_voltage_dropout_hi'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_UpperRR / 10,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_voltage_dropout_lo'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_LowerRR / 10,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_u1_limit_hi'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_1UpLimit / 10,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_u2_limit_lo'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_2LoLimit,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_u1_time_hi'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_1UpTime / 1000,
        unit: 's',
        hideFractionDigits: false
      },
      {
        label: _vm.$t('Web.expert_view_u2_time_lo'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_2LoTime / 1000,
        unit: 's',
        hideFractionDigits: false
      },
      {
        label: _vm.$t('Web.expert_view_f1_limit_hi'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).F_1UpLimit / 1000,
        unit: 'Hz',
        hideFractionDigits: false
      },
      {
        label: _vm.$t('Web.expert_view_f1_limit_lo'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).F_1LoLimit / 1000,
        unit: 'Hz',
        hideFractionDigits: false
      },
      {
        label: _vm.$t('Web.expert_view_u1_limit_lo'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_1LoLimit / 10,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_u1_time_lo'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_1LoTime / 1000,
        unit: 's',
        hideFractionDigits: false
      },
      {
        label: _vm.$t('Web.expert_view_u_ave_hi'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).U_UpAve / 10,
        unit: '%',
        hideFractionDigits: true
      },
      {
        label: _vm.$t('Web.expert_view_f_derate'),
        value: (_vm.latestPowerInverterReadApp.parameters || {}).F_Derate / 1000,
        unit: 'Hz',
        hideFractionDigits: false
      },
      {
        label: _vm.$t('Web.expert_view_f_grad_reduc'),
        value: _vm.calcFGradeReducValue((_vm.latestPowerInverterReadApp.parameters || {}).F_GradReduc),
        unit: '%',
        hideFractionDigits: true
      }
    ]}},[_vm._v("\n    "+_vm._s(_vm.$t('Web.expert_view_tor_read_title'))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }